import {isStaff} from '@github-ui/stats'
import {testIdProps} from '@github-ui/test-id-props'
import {Label, Link, ToggleSwitch} from '@primer/react'
import {useCallback} from 'react'

import {useTableHierarchy} from '../../features/sub-issues/use-table-hierarchy'
import {ViewerPrivileges} from '../../helpers/viewer-privileges'
import type {BaseViewState, ViewIsDirtyStates} from '../../hooks/use-view-state-reducer/types'
import {PotentiallyDirty} from '../potentially-dirty'
import styles from './hierarchy-toggle.module.css'

export function HierarchyToggle({view}: {view: BaseViewState & ViewIsDirtyStates}) {
  const {hasWritePermissions} = ViewerPrivileges()
  const {hierarchyEnabled: enabled, setHierarchyEnabled: setEnabled} = useTableHierarchy()

  const onClick = useCallback(() => {
    setEnabled(view.number, !enabled)
  }, [enabled, setEnabled, view.number])

  const feedbackLink = isStaff()
    ? 'https://gh.io/nested-sub-issue-feedback-internal'
    : 'https://gh.io/nested-sub-issue-feedback'

  return (
    <div className={styles.toggleContainer}>
      <div className="d-flex align-items-center gap-2">
        <PotentiallyDirty
          isDirty={view.isTableHierarchyEnabledDirty}
          hideDirtyState={!hasWritePermissions}
          {...testIdProps('hierarchy-dirty')}
        >
          <div id="hierarchy-enabled-label">Show hierarchy</div>
        </PotentiallyDirty>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={feedbackLink}
          aria-label="Beta - Provide feedback on hierarchy view (opens in new tab)"
        >
          <Label variant="success">Beta</Label>
        </Link>
      </div>
      <ToggleSwitch size="small" aria-labelledby="hierarchy-enabled-label" checked={enabled} onClick={onClick} />
    </div>
  )
}

try{ HierarchyToggle.displayName ||= 'HierarchyToggle' } catch {}